// @flow
import { useState, useCallback } from 'react';
import equals from 'ramda/es/equals';

import * as paymentStatuses from 'app/common/actions/shop/order/paymentStatuses';
import * as shippingStatuses from 'app/common/actions/shop/order/shippingStatuses';


export type FilterState = {
  paymentStatus: Array<$Values<typeof paymentStatuses>>,
  shippingStatus: Array<$Values<typeof shippingStatuses>>,
}

export type IncommingPayment = {
  id: 'paymentStatus',
  value: Array<$Values<typeof paymentStatuses>>,
}

export type IncommingShipping = {
  id: 'shippingStatus',
  value: Array<$Values<typeof shippingStatuses>>,
}

export const filterDefaultState: FilterState = {
  paymentStatus: [],
  shippingStatus: [],
};

export default function () {
  const [filterShow, setFilterShow] = useState();
  const handelToggleFilter = useCallback(() => {
    setFilterShow(state => !state);
  }, []);

  const [filterState, setFilterState] = useState<FilterState>(filterDefaultState);
  // const handelChangeFilter = useCallback((data: FilterState) => {
  //   setFilterState(data);
  // }, []);
  const handleResetFilter = useCallback(() => {
    setFilterState(filterDefaultState);
  }, []);

  return [
    [filterShow, handelToggleFilter],
    [filterState, setFilterState],
    [equals(filterState, filterDefaultState), handleResetFilter], // TODO сравнение
  ];
}
